import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createBlock as _createBlock, toDisplayString as _toDisplayString, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "text-v_dark_gray mt-4" }
const _hoisted_2 = { class: "flex justify-between items-center mt-2" }
const _hoisted_3 = {
  key: 0,
  class: "text-center text-v_medium_gray"
}
const _hoisted_4 = {
  key: 1,
  class: "text-center text-v_medium_gray"
}
const _hoisted_5 = {
  key: 2,
  class: "flex justify-between items-center text-v_green"
}
const _hoisted_6 = { class: "relative w-[20rem] h-[2rem]" }
const _hoisted_7 = { class: "overflow" }
const _hoisted_8 = { class: "ml-[-4.5rem] mt-1" }
const _hoisted_9 = {
  key: 2,
  class: "total"
}
const _hoisted_10 = { style: {"color":"#18b95f"} }

import { useDropzone } from "vue3-dropzone"
import { DropzoneContainer, FileContainer, Button } from "../atoms"
import { ref } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'Dropzone',
  props: {
	total: { type: String, required: true },
	width: { type: Number }
},
  emits: ["getFile"],
  setup(__props, { emit }) {

let docFile = ref<File[]>([])



function onDrop(acceptFiles: any) {
	console.log(acceptFiles[0].name)

	docFile.value = acceptFiles

	emit("getFile", acceptFiles)
}

const { getRootProps, getInputProps, isDragReject, isDragAccept } = useDropzone(
	{
		onDrop,
		multiple: false,
		accept: "application/pdf",
	}
)



return (_ctx: any,_cache: any) => {
  const _component_H2 = _resolveComponent("H2")!
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_H2, { class: "text-left font-[700]" }, {
      default: _withCtx(() => [
        _createTextVNode("Escolher NF:")
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      (_unref(docFile).length == 0)
        ? (_openBlock(), _createBlock(_unref(DropzoneContainer), _mergeProps({ key: 0 }, _unref(getRootProps)(), {
            bd: _unref(isDragAccept) ? '#4AD989' : _unref(isDragReject) ? '#FF0F00' : '',
            width: __props.width || 26
          }), {
            default: _withCtx(() => [
              _createElementVNode("input", _normalizeProps(_guardReactiveProps(_unref(getInputProps)())), null, 16),
              (_unref(isDragAccept))
                ? (_openBlock(), _createElementBlock("p", _hoisted_3, " Solte seu pdf aqui "))
                : (_unref(isDragReject))
                  ? (_openBlock(), _createElementBlock("p", _hoisted_4, " Esse formato de arquivo não é aceito "))
                  : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createVNode(_component_v_icon, { icon: "mdi-file-upload-outline" }),
                      _createVNode(_unref(Button), {
                        w: "5rem",
                        h: "1.68rem",
                        background: "#4AD989",
                        bd: "#4AD989",
                        color: "#000",
                        class: "text-[0.8rem] active:scale-90 text-body-2"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Selecionar ")
                        ]),
                        _: 1
                      })
                    ]))
            ]),
            _: 1
          }, 16, ["bd", "width"]))
        : (_openBlock(), _createBlock(_unref(FileContainer), { key: 1 }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(docFile)[0].name), 1)
              ]),
              _createElementVNode("button", {
                class: "text-[1.5rem] text-v_dark_blue w-8 active:scale-90",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('getFile', []), (_isRef(docFile) //@ts-ignore
 ? docFile.value = [] : docFile = [])))
              }, " x ")
            ]),
            _: 1
          })),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_v_icon, {
          icon: "mdi-help-circle-outline",
          class: "tooltip"
        })
      ]),
      (__props.total && __props.total != '0')
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("p", _hoisted_10, _toDisplayString(__props.total), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})